import api from './api';
import { CPB_URL } from './servers';

export const getAuthentication = (data) => api.post(`${CPB_URL}/ws/iniciarSesion`, data);

export const getEstados = (data) => api.post(`${CPB_URL}/estados/getEstados`, data);

export const getIndicadores = (data) => api.post(`${CPB_URL}/home/getIndicadores`, data);

export const getActiveCaptcha = (data) => api.post(`${CPB_URL}/home/getCfgCaptcha`, data);

export const getMenuSistemas = (data) => api.post(`${CPB_URL}/menuSistemas/getMenuSistemas`, data);

export const getRedirectVigap = (data) => api.post(`${CPB_URL}/menuSistemas/redirectToVigap`, data);

export const getCerrarSesion = (data) => api.post(`${CPB_URL}/ws/cerrarSesion`, data);
